"use strict";
//
// The UI compoent for a single note.
//
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteEditor = void 0;
var React = require("react");
var react_contenteditable_1 = require("react-contenteditable");
var NoteEditor = /** @class */ (function (_super) {
    __extends(NoteEditor, _super);
    function NoteEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.noteRef = React.createRef();
        return _this;
    }
    NoteEditor.prototype.componentDidMount = function () {
        if (this.props.hasFocus) {
            this.giveFocus();
        }
    };
    NoteEditor.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (nextProps.hasFocus) {
            this.giveFocus();
        }
        return true;
    };
    //
    // Gives input focus to this note.
    //
    NoteEditor.prototype.giveFocus = function () {
        if (this.noteRef.current) {
            // TypeScript won't let me call "focus" on a div.
            // I have to be sneaky and force it.
            this.noteRef.current.focus();
            if (this.props.onFocused) {
                this.props.onFocused();
            }
        }
    };
    //
    // Event raise on key down.
    //
    NoteEditor.prototype.onKeyDown = function (evt) {
        if (this.props.onCreateNote && evt.key === "Enter") {
            this.props.onCreateNote();
            evt.preventDefault();
            return;
        }
        if (this.props.onDeleteNote && evt.key === "Delete" && evt.ctrlKey) {
            this.props.onDeleteNote();
            evt.preventDefault();
            return;
        }
        if (evt.key === "Tab") {
            if (evt.shiftKey) {
                if (this.props.onUnindentNote) {
                    this.props.onUnindentNote();
                }
            }
            else {
                if (this.props.onIndentNote) {
                    this.props.onIndentNote();
                }
            }
            evt.preventDefault();
            return;
        }
        if (this.props.onFocusNext && evt.key === "ArrowDown") {
            this.props.onFocusNext();
            evt.preventDefault();
            return;
        }
        if (this.props.onFocusPrev && evt.key === "ArrowUp") {
            this.props.onFocusPrev();
            evt.preventDefault();
            return;
        }
    };
    NoteEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_contenteditable_1.default, { innerRef: this.noteRef, onKeyDown: this.onKeyDown, html: this.props.text, onChange: function (evt) {
                if (_this.props.onTextChange) {
                    _this.props.onTextChange(evt.target.value);
                }
            } }));
    };
    return NoteEditor;
}(React.Component));
exports.NoteEditor = NoteEditor;
//# sourceMappingURL=note-editor.js.map